const KEY = 'brasiltec-clp-desktop-login'

export type DesktopClpRequest = { port: number; state: string; createdAt: number }

const valid = (value: DesktopClpRequest | null): value is DesktopClpRequest => Boolean(
  value
  && Number.isSafeInteger(value.port) && value.port >= 1024 && value.port <= 65535
  && /^[0-9a-f]{64}$/.test(value.state)
  && Number.isFinite(value.createdAt) && Date.now() - value.createdAt < 5 * 60 * 1000
)

export function captureDesktopClpRequest(): DesktopClpRequest | null {
  if (typeof window === 'undefined') return null
  try {
    const params = new URLSearchParams(window.location.search)
    const port = Number(params.get('desktop_clp_port'))
    const state = params.get('desktop_clp_state') || ''
    if (Number.isSafeInteger(port) && port >= 1024 && port <= 65535 && /^[0-9a-f]{64}$/.test(state)) {
      const request = { port, state, createdAt: Date.now() }
      window.sessionStorage.setItem(KEY, JSON.stringify(request))
      return request
    }
    const saved = JSON.parse(window.sessionStorage.getItem(KEY) || 'null') as DesktopClpRequest | null
    if (valid(saved)) return saved
    window.sessionStorage.removeItem(KEY)
  } catch { /* Storage may be unavailable. */ }
  return null
}

export function clearDesktopClpRequest() {
  try { window.sessionStorage.removeItem(KEY) } catch { /* Storage may be unavailable. */ }
  const url = new URL(window.location.href)
  url.searchParams.delete('desktop_clp_port')
  url.searchParams.delete('desktop_clp_state')
  window.history.replaceState(window.history.state, '', url.pathname + url.search + url.hash)
}
